import $ from 'jquery';
window.$ = window.$ || $;
window.jQuery = window.jQuery || $;

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';

const initEliteEarlyBirdsSlider = () => {
  const slider = document.querySelector('[data-elite-early-birds-slider]');
  if (!slider) {
    return;
  }

  const $slider = $(slider);
  if ($slider.hasClass('slick-initialized')) {
    return;
  }

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: 'linear',
    infinite: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
};

const scheduleSliderInit = () => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => initEliteEarlyBirdsSlider(), { timeout: 1200 });
  } else {
    setTimeout(() => initEliteEarlyBirdsSlider(), 400);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleSliderInit);
} else {
  scheduleSliderInit();
}